import { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import apiClient from "../../api/ApiClients";
import CustomAlertDialog from "../../components/alerts/CustomAlertDialog";
import Sidebar from "../../components/layout/Sidebar";

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const [blogToDelete, setBlogToDelete] = useState(null);
  const navigate = useNavigate();

  const fetchBlogs = async () => {
    try {
      const res = await apiClient.request("blog", "GET");
      setBlogs(res.blogs || []);
    } catch (e) {
      toast.error("Failed to fetch blogs");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleDeleteBlog = async () => {
    try {
      await apiClient.request(`blog/${blogToDelete}`, "DELETE");
      toast.success("Blog deleted");
      setShowAlert(false);
      fetchBlogs();
    } catch (e) {
      toast.error("Failed to delete blog");
    }
  };

  return (
    <>
      <Sidebar />
      <div className="wrapper" style={{ padding: "0px" }}>
        <div className="customHeader">
          <div className="headerContent">
            <h2>Blogs</h2>
            <Button onClick={() => navigate("/admin/blog/add")}>Add New</Button>
          </div>
          <hr />
        </div>
        <div className="px-4">
          {loading ? (
            <div>Loading...</div>
          ) : (
            <Table bordered hover>
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Thumbnail</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {blogs.map((blog) => (
                  <tr key={blog._id}>
                    <td>{blog.title}</td>
                    <td>
                      {blog.thumbnail && (
                        <img
                          src={blog.thumbnail}
                          alt="Thumbnail"
                          style={{ maxWidth: 80, maxHeight: 80 }}
                        />
                      )}
                    </td>
                    <td>
                      <Button
                        variant="outline-dark"
                        onClick={() => navigate(`/admin/blog/edit/${blog._id}`)}
                      >
                        Edit
                      </Button>{" "}
                      <Button
                        variant="outline-danger"
                        onClick={() => {
                          setBlogToDelete(blog._id);
                          setShowAlert(true);
                        }}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
          <CustomAlertDialog
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            title="Delete"
            subtitle="Are you sure you want to delete this blog?"
            buttonText="Delete"
            onCancel={() => setShowAlert(false)}
            onClick={handleDeleteBlog}
            isDanger
          />
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default BlogPage;
